import { render, staticRenderFns } from "./SpeakingWords.vue?vue&type=template&id=a8684e7a&scoped=true&"
import script from "./SpeakingWords.vue?vue&type=script&lang=js&"
export * from "./SpeakingWords.vue?vue&type=script&lang=js&"
import style0 from "./SpeakingWords.vue?vue&type=style&index=0&id=a8684e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8684e7a",
  null
  
)

export default component.exports